import Checkbox from './checkbox'

export const AmuiCheckbox = Checkbox

export default Vue => Vue.component(Checkbox.name, Checkbox)
